import React from 'react';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import Button, { ILink } from 'tbk-components/src/components/Button';

export interface IContentTileArticleProps extends IBaseElementProps {
	tileImage?: IImage;
	tileReadTime?: string;
	tileHeading?: string;
	tileLocation?: string;
	tileDate?: string;
	tileTags?: ILink[];
	tileDescription?: string;
	tileLink?: ILink;
}

const ContentTileArticle: React.FC<IContentTileArticleProps> = ({
	tileImage,
	tileReadTime,
	tileHeading,
	tileLocation,
	tileDate,
	tileTags,
	tileDescription,
	tileLink,
}) => (
	<div className="card rounded-5 border-0">
		{tileLink && (
			<div className="article-tile-link-container rounded-5 overflow-hidden">
				<div className="article-tile-link-content p-3 p-md-5">
					{/* In order to make sure all elements are clickable we have to list each child item one by one. */}
					{tileImage && (
						<a
							href={tileLink.href}
							target={tileLink.target}
							className="article-tile-link-image d-inline-flex"
						>
							<div className="card-img-top rounded-5 overflow-hidden">
								<Image className="img-fluid" {...tileImage} />
							</div>
						</a>
					)}
					{tileReadTime && (
						<p className="card-text small mb-0">{tileReadTime}</p>
					)}
					{tileHeading && (
						<a
							href={tileLink.href}
							target={tileLink.target}
							className="article-tile-link-title"
						>
							<h4 className="card-title pe-md-2">
								{tileHeading}
							</h4>
						</a>
					)}
					{tileLocation && (
						<p className="card-text small mb-3">{tileLocation}</p>
					)}
					{tileDate && (
						<p className="card-text h6 mb-4">{tileDate}</p>
					)}
					{tileTags && tileTags.length > 0 && (
						<div className="card-tags mt-3 mb-1">
							{tileTags.map((tag, index) => (
								<Button
									className="card-tag-link btn btn-sm btn-light mb-2 me-2"
									key={index}
									{...tag}
								/>
							))}
						</div>
					)}
					{tileDescription && (
						<p className="card-text mb-4">{tileDescription}</p>
					)}
					{tileLink && (
						<div className="card-link">
							<Button
								className="link-primary text-decoration-none d-inline-flex align-items-center"
								{...tileLink}
							>
								<span className="icon icon-arrow-right"></span>
							</Button>
						</div>
					)}
					<a
						href={tileLink.href}
						target={tileLink.target}
						className="article-tile-link-cover"
						title={tileHeading}
					></a>
				</div>
			</div>
		)}
	</div>
);

export default ContentTileArticle;
